import { Button, Grid, Paper } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import SearchField from 'src/shared/components/form/searchField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useTranslation } from 'react-i18next';
import { PersonAdd } from '@mui/icons-material';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useNavigate } from 'react-router-dom';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import { DonorDataGrid } from '../components/donorDataGrid';
import { DonorCreateModal } from '../components/donorCreateModal';

export const DonorsListPage = () => {
  const { t } = useTranslation(['gift']);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [searchString, setSearchString] = useState<string>('');
  const [tempSearchString, setTempSearchString] = useState<string>('');
  const [createMode, setCreateMode] = useState<boolean>(false);

  useEffect(() => {
    if (tempSearchString === '') {
      setSearchString('');
    }
    if (tempSearchString.length >= 2) {
      setSearchString(tempSearchString);
    } else {
      setSearchString('');
    }
  }, [tempSearchString]);

  const loadingCallback = useCallback((isLoading: boolean) => {
    setLoading(isLoading);
  }, []);

  return (
    <>
      <GridWrapper>
        <Grid item xs>
          <MainContentHeader title={t('gift:donors')} />
        </Grid>
        <Grid item xs='auto' style={{ display: 'flex', justifyContent: 'flex-end', gridColumnGap: '5px' }}>
          <Button
            onClick={() => setCreateMode(true)}
            variant='contained'
            color='secondary'
            startIcon={<PersonAdd />}
            disableElevation
            disabled={loading}
          >
            {t('gift:createDonor.header')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <PageFilterSection leftContent={<SearchField onSearch={(newSearchString) => setTempSearchString(newSearchString)} />} />
            <DonorDataGrid loadingCallback={loadingCallback} searchString={searchString} />
          </Paper>
        </Grid>
      </GridWrapper>
      {createMode && (
        <DonorCreateModal
          onClose={() => setCreateMode(false)}
          onSave={(id?: number) => {
            setCreateMode(false);
            if (id) navigate(`${RoutesEnum.DonorsDetail}/${id}`);
          }}
          modalOpen={createMode}
        />
      )}
    </>
  );
};
